import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter, Output, Directive } from '@angular/core';
import { FilterParams, StarbaseDataService } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';
import { Log_ext } from '../models/log-ext';
import { StarbaseNotificationService, StarbaseNotificationSentiment } from 'starbase-notification';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class LogDataService extends StarbaseDataService<Log_ext> {
  @Output() recordHistoryOpener = new EventEmitter<FilterParams<Log_ext>>();

  protected _staleDataTimeout: 1500;
  protected _getOneUri = '/api/Log/';
  protected _getAllUri = '/api/Log/GetLogs';
  protected _postUri: string;
  protected _putUri: string;
  protected _deleteUri: string;
  protected _broadSearchUri = '/api/Log/GetLogsByPage';


  private _lastRetrievedEntityName = '';

  constructor(private _http: HttpClient, private _webAPI: WebApiService, private notiSvc: StarbaseNotificationService) {
    super(_http, _webAPI);
  }

  public get lastRetrievedEntityName(): string {
    return this._lastRetrievedEntityName;
  }

  // getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<Log_ext>): Observable<FilterParams<Log_ext>> {
  //   filterParams.collection = [];
  //   return this._http.post<FilterParams<Log_ext>>(this.server + url, filterParams, {
  //     headers: this._webAPI.getApiHeaders('post')}).pipe(
  //       retry(this.defaultRetries),
  //       catchError(e => this._webAPI.handleRequestError(e))
  //     );
  // }

  getRecordHistoryData(guid: string): void {
    if (!guid || guid === '') {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Unknown entity',
          'Sorry, record history is not available for that entity.',
          undefined, undefined,
          StarbaseNotificationSentiment.Notice
        )
      );
      return;
    }
    const fp = new FilterParams<Log_ext>();
    fp.rpp = 10;
    fp.addToFilter('EntityGuid', guid);
    // eslint-disable-next-line import/no-deprecated
    this.getDataByFilterParamsBroadSearch(this.broadSearchUri, fp).subscribe(d => {
      this._lastRetrievedEntityName = (d.collection.length) ? d.collection[0].entityName : '';
      this.recordHistoryOpener.emit(d);
    });
  }

  public setLastRetrievedEntityName(val: string) {
    this._lastRetrievedEntityName = val;
  }

}
